import { render, staticRenderFns } from "./GuidePage.vue?vue&type=template&id=36746944&"
import script from "./GuidePage.vue?vue&type=script&lang=js&"
export * from "./GuidePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports